import { Option } from '@repo/toolkit/types'
import { FacesEvaluationVariantType } from '@repo/ui/faces-evaluation'

export enum EvalutationEnum {
  GOOD = 'GOOD',
  MIDDLE = 'MIDDLE',
  BAD = 'BAD'
}

export const mapEvaluationFace: Record<EvalutationEnum, FacesEvaluationVariantType> = {
  BAD: 'sad',
  GOOD: 'happy',
  MIDDLE: 'normal'
}

export const mapFaceEvaluation: Record<FacesEvaluationVariantType, Option<EvalutationEnum>> = {
  happy: {
    label: 'Happy',
    value: EvalutationEnum.GOOD
  },
  normal: {
    label: 'Normal',
    value: EvalutationEnum.MIDDLE
  },
  sad: {
    label: 'Sad',
    value: EvalutationEnum.BAD
  }
}

export const evalutationEnumMapping: Record<
  EvalutationEnum,
  Option<EvalutationEnum> & { letter: string }
> = {
  /** please keep the order in a descending  order */
  [EvalutationEnum.GOOD]: {
    label: 'Bon',
    letter: 'A',
    value: EvalutationEnum.GOOD
  },
  [EvalutationEnum.MIDDLE]: {
    label: 'Moyen',
    letter: 'B',
    value: EvalutationEnum.MIDDLE
  },
  [EvalutationEnum.BAD]: {
    label: 'Mauvais',
    letter: 'C',
    value: EvalutationEnum.BAD
  }
}
